import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

export const REMOVE_RDID_TEST = 'RDID_homepage_Nov2024';

export const trackRemoveRDIDTest = (): void => {
    trackAbTestV2Variant(REMOVE_RDID_TEST);
};
